// src/App.js
import React, { useState } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

function App() {
  const [usuario, setUsuario] = useState(() => {
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('usuario');
    return savedToken && savedUser ? JSON.parse(savedUser) : null;
  });

  const handleLogin = (userData) => {
    setUsuario(userData);
    localStorage.setItem('token', userData.token);
    localStorage.setItem('usuario', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUsuario(null);
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
  };

  return (
    <>
    {usuario ? (
      <Dashboard usuario={usuario} onLogout={handleLogout} />
    ) : (
      <Login onLogin={handleLogin} />
    )}
    </>
  );
}

export default App;
